import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import BillingManager from "./BillingManager";

export default function BillingPage() {
  return (
    
      <BillingManager />
   
  );
}
